{
  "REGISTER": {
    "TRY_WOOT": "Create an account",
    "TITLE": "Registrera",
    "TESTIMONIAL_HEADER": "All it takes is one step to move forward",
    "TESTIMONIAL_CONTENT": "You're one step away from engaging your customers, retaining them and finding new ones.",
    "TERMS_ACCEPT": "By creating an account, you agree to our <a href=\"https://chat.jarabot.com/terms\">T & C</a> and <a href=\"https://chat.jarabot.com/privacy-policy\">Privacy policy</a>",
    "TERMS_LINKS": "<a href=\"https://chat.jarabot.com/terms\">Användarvillkor</a> - <a href=\"https://chat.jarabot.com/privacy-policy\">Integritetspolicy</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Sign up with Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Company name",
      "PLACEHOLDER": "Enter your company name. E.g., Wayne Enterprises",
      "ERROR": "Company name is too short."
    },
    "FULL_NAME": {
      "LABEL": "Fullständigt namn",
      "PLACEHOLDER": "Enter your full name. E.g., Bruce Wayne",
      "ERROR": "Fullständigt namn är för kort."
    },
    "EMAIL": {
      "LABEL": "E-postadress, arbete",
      "PLACEHOLDER": "Enter your work email address. E.g., bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Please enter a valid work email address."
    },
    "PASSWORD": {
      "LABEL": "Lösenord",
      "PLACEHOLDER": "Lösenord",
      "ERROR": "Lösenordet är för kort.",
      "IS_INVALID_PASSWORD": "Password should contain atleast 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirm password",
      "PLACEHOLDER": "Confirm password",
      "ERROR": "Lösenorden matchar inte."
    },
    "API": {
      "SUCCESS_MESSAGE": "Registreringen lyckades",
      "ERROR_MESSAGE": "Could not connect to chat server. Please try again."
    },
    "SUBMIT": "Create account",
    "HAVE_AN_ACCOUNT": "Har du redan ett konto?"
  }
}
